import {__loco} from "../../utils/localization";


/**
 * Actions related to confirm button of the order form
 */
export class ConfirmButton
{
    /**
     * Initialize confirm button
     *
     * @param $button
     */
    constructor($button)
    {
        this.$button = $button;
    }


    /**
     * Update confirm & pay button to "Processing payment"
     */
    buttonValidatingOrder()
    {
        this.$button.addClass('--disabled');
        this.setButtonText(__loco('Validating your order...'));
    }

    /**
     * Update confirm & pay button to "Processing payment"
     */
    buttonProcessingPayment()
    {
        this.$button.addClass('--disabled');
        this.setButtonText(__loco('Processing payment...'));
    }

    /**
     * Button payment error
     */
    buttonPaymentError()
    {
        this.$button.addClass('--disabled');
        this.setButtonText(__loco('Payment failed.'));
    }

    /**
     * Button payment success
     */
    buttonPaymentSuccess()
    {
        this.$button.addClass('--disabled');
        this.setButtonText(__loco('Payment successful!'));
    }

    /**
     * Disable confirm button
     */
    disableConfirmButton(){
        this.$button.addClass('--disabled');
    }

    /**
     * Reset button
     */
    resetButton()
    {
        this.enableConfirmButton();
        this.setButtonText(__loco('Confirm and pay'));
    }

    /**
     * Enable confirm button
     */
    enableConfirmButton() {
        this.$button.removeClass('--disabled');
    }

    /**
     * Set button text
     *
     * @param text
     */
    setButtonText(text) {
        this.$button.html(`<p class="ellipse__button_text">${text}</p>`);
    }
}
